import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import { useLoading } from "../../../../context/loading";
import { useUserDetails } from "../../../../context/auth";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import BASEURL from "../../../Utils/Baseurl";
import {
  createleaveclarification,
  updateLeaveclarification,
  getbyid,
  deleteleaveclarification,
} from "../mutation";

const AddLeavecalrificationForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    employeeName: "",
    employeeId: "",
    leaveType: "",
    department: "",
    fromDate: "",
    toDate: "",
    reason: "",
    userid: "",
    reasonStatus: "unchecked",
    employeeNameStatus: "unchecked",
    employeeIdStatus: "unchecked",
    leaveTypeStatus: "unchecked",
    departmentStatus: "unchecked",
    fromDateStatus: "unchecked",
    toDateStatus: "unchecked",
  });
  const { circleLoading, setCirleLoading } = useLoading();

  const { display, setdisplay, AccessData, update, setupdate, user } =
    useUserDetails();

  const [id, setId] = useState(null);
  const [leaveoptions, setleaveoptions] = useState([]);
  const [departmentoptions, setDepartmentOptions] = useState([]);

  const [viewData, setViewData] = useState("");
  const [depdisplay, setdepdisplay] = useState(false);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const alldata = sessionStorage.getItem("user");
  let userdata = JSON.parse(alldata);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });

  const [togglePage, setTogglePage] = useState({
    view: true,
    edit: true,
  });

  const [designationData, setDesignationData] = useState({
    departmentName: "",
    designationName: "",
    departmentNameStatus: "unchecked",
    designationNameStatus: "unchecked",
  });

  const [resource, setResource] = useState({
    departmentName: [],
  });

  const [originalDesigntionData, setOriginalDesignationData] = useState({
    departmentName: "",
    designationName: "",
    departmentNameStatus: "",
    designationNameStatus: "",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    }

    getleavetype();
    fetchAllDepartment();
  }, []);

  useEffect(() => {
    onfilterData();
  }, [viewData]);

  const getleavetype = async () => {
    let query = `query LeaveBalanceByUser($userId: Int!) {
  leaveBalanceByUser(userId: $userId) {
  id
    leaveType
    balanceLeave
    id
    active
  }
}`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query,
          variables: { userId: user?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data.data.leaveBalanceByUser;

      let filterdata = data.filter((val) => val.active == true);

      console.log("hxssbbsd:", filterdata);

      const formattedOptions = filterdata
        .filter((item) => {
          const leaveType = item?.leaveType;

          if (!leaveType || leaveType === "work_from_home") {
            return false;
          }

          if (leaveType === "paternity_leave") {
            return (
              userdata.gender === "Male" &&
              userdata.matural_status === "Married"
            );
          }

          if (leaveType === "maternity_leave") {
            return (
              userdata.gender === "Female" &&
              userdata.matural_status === "Married"
            );
          }
          if (leaveType === "adoption_leave") {
            return userdata.gender === "Female";
          }
          if (leaveType === "surrogacy_leave") {
            return userdata.gender === "Female";
          }

          return true;
        })
        .map((item) => ({
          value: item.id,
          label: item.leaveType.replace(/_/g, " ").toUpperCase(),
          mainvalue: item.leaveType,
        }));

      let resultdata = formattedOptions.filter(
        (val) => val.label != "WORK FROM HOME"
      );

      const temp = [];
      filterdata?.map((item) => {
        const leaveType = item?.leaveType;

        if (leaveType !== "loss_of_pay" && leaveType !== "work_from_home") {
          if (leaveType === "paternity_leave") {
            if (
              userdata.gender === "Male" &&
              userdata.matural_status === "Married"
            ) {
              temp.push(item);
            }
          } else if (leaveType === "maternity_leave") {
            if (
              userdata.gender === "Female" &&
              userdata.matural_status === "Married"
            ) {
              temp.push(item);
            }
          } else if (leaveType === "adoption_leave") {
            if (userdata.gender === "Female") {
              temp.push(item);
            }
          } else if (leaveType === "surrogacy_leave") {
            if (userdata.gender === "Female") {
              temp.push(item);
            }
          } else {
            temp.push(item);
          }
        }
      });

      const formatted = temp.map((item) => ({
        count: item.balanceLeave,
        leavetype: item.leaveType,
        id: item.leaveType?.id,
      }));

      setleaveoptions(formattedOptions);
    } catch (error) {
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const allDepartment = `
query {
            allDepartment {
                id
                departmentName
                departmentCode
            }
}`;

  const fetchAllDepartment = async () => {
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: allDepartment,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Extract department data from the response
      const departmentList = response.data.data.allDepartment;
      const options = departmentList.map((dept) => ({
        label: dept.departmentName,
        value: dept.id,
      }));

      let data = options.filter((x) => x.label == user.department);
      setDepartmentOptions(options);
      setFormData({
        ...formData,
        department: data[0] ? data[0] : "",
        departmentStatus: "success",
        employeeName: user.first_name,
        employeeId: user.empid,
        userid: user.id,
        employeeNameStatus: "success",
        employeeIdStatus: "success",
      });
    } catch (error) {
      console.error("Error Fetching Data: ", error);
    }
  };

  const getInitData = async (id) => {
    const query = getbyid;
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("responsesss:", response);
      // Extract Leavetype data from the response
      const departmentRowdata =
        response.data.data.leaveClarificationById.leaveClarification;
      const departmentNameData =
        response.data.data.leaveClarificationById?.leaveClarification;
      console.log("responsesss:", departmentRowdata);
      setViewData(departmentNameData);
      setdepdisplay(true);
      setFormData({
        ...formData,
        employeeName: user.first_name,
        employeeId: user.empid,
        userid: user.id,
        employeeNameStatus: "success",
        employeeIdStatus: "success",
        leaveType: {
          label: departmentRowdata.leaveType.name,
          value: departmentRowdata.leaveType.id,
        },
        department: {
          label: departmentRowdata.department.departmentName,
          value: departmentRowdata.department.id,
        },
        fromDate: departmentRowdata.fromDate,
        toDate: departmentRowdata.toDate,
        reasonStatus: "success",
        employeeNameStatus: "success",
        employeeIdStatus: "success",
        leaveTypeStatus: "success",
        departmentStatus: "success",
        fromDateStatus: "success",
        toDateStatus: "success",
      });
      // setDesignationData({
      //   departmentName: {
      //     value: departmentRowdata.departmentName,
      //     label: departmentRowdata.departmentName,
      //   },
      //   designationName: departmentRowdata.designation,
      //   departmentNameStatus: departmentRowdata?.departmentName
      //     ? "success"
      //     : "unchecked",
      //   designationNameStatus: departmentRowdata.designation
      //     ? "success"
      //     : "unchecked",
      // });

      // setOriginalDesignationData({
      //   departmentName: {
      //     value: departmentRowdata.departmentName,
      //     label: departmentRowdata.departmentName,
      //   },
      //   designationName: departmentRowdata.designation,
      // });

      setTogglePage({
        ...togglePage,
        view: true,
      });
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onEditDesignationSubmit = async () => {
    setCirleLoading(true);
    const query = updateLeaveclarification;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: id,
            userId: formData.userid,
            leaveTypeId: formData.leaveType?.value,
            departmentId: formData.department?.value,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            leaveBalanceInquiry: true,
          },
        }),
      });

      console.log("response:", response.data);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setCirleLoading(false);
      setSnackBar({
        ...snackBar,
        Success: true,
      });
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Leave Clarification Updated Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/leaveclarify");
    } catch (error) {
      console.error("responseError:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };
  console.log(designationData, "designationData");

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteDesignationSubmit();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteDesignationSubmit = async () => {
    const query = deleteleaveclarification;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      if (response.data.data.deleteLeaveClarification.success) {
        console.log("Designation deleted successfully!");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Leave Clarification deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/designation");
      } else {
        console.log(
          "Error deleting Leave Clarification:",
          response.data.data.deleteLeaveClarification.message
        );
      }
    } catch (error) {
      console.error("An error occurred while deleting the designation:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onDesignationSubmit = async () => {
    setCirleLoading(true);
    const query = createleaveclarification;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            userId: formData.userid,
            leaveTypeId: formData.leaveType?.value,
            departmentId: formData.department?.value,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            leaveBalanceInquiry: true,
          },
        }),
      });

      console.log("response:", response.data);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setCirleLoading(false);
      setSnackBar({
        ...snackBar,
        Success: true,
      });
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Leave Clarification Submitted Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/leaveclarify");
    } catch (error) {
      console.error("responseError:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  //   const handleDesignationDatachange = (event, selectEvent) => {
  //     console.log("selectEvent:", selectEvent, event?.label);
  //     let designationState = { ...formData };

  //     if (event?.target === undefined && selectEvent) {
  //       if (selectEvent.name === "departmentName") {
  //         const lengthRegex = new RegExp("^[A-Za-z0-9]");
  //         if (lengthRegex.test(event?.label) === true) {
  //           designationState[selectEvent.name + "Status"] =
  //             event?.label === undefined ? "unchecked" : "success";
  //         } else {
  //           designationState[selectEvent.name + "Status"] =
  //             selectEvent.value === "" ? "unchecked" : "error";
  //         }
  //       }
  //       designationState[selectEvent.name] = event;
  //     } else {
  //       const changeAllowed = true;
  //       switch (event.target.name) {
  //         case "designationName":
  //           {
  //             const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");

  //             if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
  //               designationState[event.target.name + "Status"] = "success";
  //             } else {
  //               designationState[event.target.name + "Status"] =
  //                 event.target.value === "" ? "unchecked" : "error";
  //             }
  //           }
  //           break;
  //       }
  //       if (changeAllowed) {
  //         designationState[event.target.name] = event.target.value;
  //       }
  //     }
  //     setFormData(designationState);
  //   };

  const handleDesignationDatachange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...formData };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "department") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "leaveType") {
        const lengthRegex = new RegExp("^.{1,100}$");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "employeeId":
          {
            const alphaNLengthRegex = new RegExp("^[a-zA-Z 0-9]{1,10}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "employeeName":
          {
            const alphaNLengthRegex = new RegExp("^[a-zA-Z ]{1,50}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "reason":
          {
            const alphaNLengthRegex = new RegExp("^.{1,100}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "fromDate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "toDate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setFormData(formState);
  };
  const onfilterData = () => {
    const filterDepartment = resource.departmentName.filter(
      (department) => department.departmentName == viewData
    );
    console.log(
      "filterDepartment:",
      viewData,
      resource.departmentName,
      filterDepartment
    );
    console.log("display:", display);
  };
  const AddDiscard = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Discards your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDiscardDesignation();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onDiscardDesignation = () => {
    setTogglePage({
      view: true,
      edit: false,
    });

    setDesignationData({
      departmentName: originalDesigntionData.departmentName,
      designationName: originalDesigntionData.designationName,
    });

    setupdate(false);
    setdepdisplay(true);
  };

  const handleAddComplaintForm = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDesignationSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
    setupdate(true);
    setdepdisplay(false);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      formData.employeeIdStatus === "success" &&
      formData.employeeNameStatus === "success" &&
      formData.employeeNameStatus === "success" &&
      formData.leaveTypeStatus === "success" &&
      formData.departmentStatus === "success" &&
      formData.fromDateStatus === "success" &&
      formData.toDateStatus === "success"
      //  &&
      // formData.reasonStatus == "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const checkFields = () => {
    let allowSubmit = false;
    if (
      designationData.departmentName ===
        originalDesigntionData.departmentName &&
      designationData.designationName === originalDesigntionData.designationName
    ) {
      allowSubmit = false;
    } else if (
      designationData.departmentName !== originalDesigntionData.departmentName
    ) {
      if (designationData.departmentNameStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (
      designationData.designationName !== originalDesigntionData.designationName
    ) {
      if (designationData.designationNameStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/designation");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "EditDesignation" && item.can_access
                ) &&
                (togglePage.edit || togglePage.view ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        {/* {togglePage.view
                          ? "View Designation Details"
                          : "Edit Designation Details"} */}
                        Add Leave Clarification
                      </MaterialTypography>
                    </Stack>

                    {display && (
                      <>
                        <ButtonGroup
                          variant="outlined"
                          aria-label="Loading button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>
                          {/* Uncomment this block to add delete functionality */}

                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      </>
                    )}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Request Details
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                ))}
            </>
          }
        />
        <CardContent sx={{ minHeight: "55vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="employeeName"
                  value={formData.employeeName}
                  onChange={handleDesignationDatachange}
                  error={formData.employeeNameStatus === "error"}
                  success={formData.employeeNameStatus === "success"}
                  disabled={true}
                />
                {formData.employeeNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Employee Name should be a maximum of 50 characters long
                      and can contain only alphabets.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee ID <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="employeeId"
                  value={formData.employeeId}
                  onChange={handleDesignationDatachange}
                  error={formData.employeeIdStatus === "error"}
                  success={formData.employeeIdStatus === "success"}
                  disabled={true}
                />
                {formData.employeeIdStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Employee ID should be a maximum of 10 Variable characters
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Leave Type <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="leaveType"
                  value={formData.leaveType}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleDesignationDatachange} //selectedValue, event
                  options={leaveoptions}
                  error={formData.leaveTypeStatus === "error" ? true : false}
                  success={
                    formData.leaveTypeStatus === "success" ? true : false
                  }
                  // isClearable
                  isDisabled={depdisplay}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Department <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="department"
                  value={formData.department}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleDesignationDatachange} //selectedValue, event
                  options={departmentoptions}
                  error={formData.departmentStatus === "error" ? true : false}
                  success={
                    formData.departmentStatus === "success" ? true : false
                  }
                  // isClearable
                  // isDisabled={depdisplay}
                  isDisabled={true}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    From Date<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="fromDate"
                  type="date"
                  value={formData.fromDate}
                  onChange={handleDesignationDatachange}
                  error={formData.fromDateStatus === "error"}
                  success={formData.fromDateStatus === "success"}
                  inputProps={{
                    max: new Date().toISOString().split("T")[0], // max today
                  }}
                />
                {formData.fromDateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Enter Start Date</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    To Date<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="toDate"
                  type="date"
                  value={formData.toDate}
                  onChange={handleDesignationDatachange}
                  error={formData.toDateStatus === "error"}
                  success={formData.toDateStatus === "success"}
                  inputProps={{
                    // max: new Date().toISOString().split("T")[0], // max today
                    min: formData.fromDate || undefined, // min fromDate
                  }}
                />
                {formData.toDateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Enter To date</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              {/* <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Reason <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="reason"
                  value={formData.reason}
                  multiline
                  rows={5}
                  onChange={handleDesignationDatachange}
                  error={formData.reasonStatus === "error"}
                  success={formData.reasonStatus === "success"}
                />
                {formData.reasonStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Reason should be a maximum of 100 variables characters
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid> */}
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {update && (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                onClick={AddDiscard}
              >
                Discard
              </MaterialButton>

              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                // disabled={!checkFields()}
                onClick={onEditDesignationSubmit}
              >
                Update
              </MaterialButton>
            </>
          )}

          {!display && (
            <>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handlecancel}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 4, marginLeft: "4px" }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleAddComplaintForm}
              >
                Submit
              </MaterialButton>
            </>
          )}
        </MaterialBox>
        {
          <MaterialSnackbar
            color="success"
            icon={<NotificationsIcon />}
            title="Message"
            content="You have been submitted successfully"
            open={snackBar.Success}
            close={() =>
              setSnackBar({
                success: false,
              })
            }
          />
        }
      </Card>
    </DashboardLayout>
  );
};

export default AddLeavecalrificationForm;
